<template>
    <Accordion :activeIndex="activeIndex" class="xl:mt-5 mt-2 w-full" v-if="lang_!='ru'">
        <AccordionTab header="How to make a payment">
            <p>
                1. Click the pay button. You will be taken to the AdvCash payment system page.
            </p>
            <p>
                2. Make sure you are on the AdvCash page at https://wallet.advcash.com/sci/ and that the address bar shows a padlock (https protocol).
            </p>
            <p>
                3. Check the payment amount and order number. If everything is correct, click the button select the payment method and click "Go to the payment".
            </p>
            <img src="/images/info/adv/adv-page-1-en.jpg">
            <p>
                4. Enter your username and password from AdvCash wallet.
                <br>
                In case you are not registered with AdvCash, click the "Register" button and follow the instructions.
            </p>
            <img src="/images/info/adv/adv-login-en.jpg">
            <p>
                5. Select the payment currency and make the payment.
            </p>
            <img src="/images/info/adv/adv-page-2-en.jpg">
            <p>
                6. After a successful payment, you will be taken to a payment information page. Click the "Return to Store" button.
            </p>


            <TabView class="w-full overflow-hidden" v-if="card">
                <TabPanel header="Payment by card">
                    <p>
                        4. Enter your bank card details in the appropriate fields. Click the "Pay" button. <br>
                        <b>Attention!</b> The payment amount will be greater than the amount specified in the order. This is due to the commission of the payment system.
                    </p>
                    <img src="/images/info/adv-en-2.png">
                    <p>
                        5. After a successful payment, you will be taken to a payment information page.
                    </p>
                    <p>
                        6. Click the "Return to Store" button.
                    </p>
                    <p>
                        7. After that, you will be taken to a page with information about the transfer. Click the "I paid for the transfer" button.
                    </p>
                </TabPanel>
                <TabPanel header="By personal account">
                    
                </TabPanel>
            </TabView>                    
        </AccordionTab>
        <AccordionTab header="How to register and top up the balance in AdvCash">
            <p> 
                1. Go to the AdvCash website at
                <a class="cursor-pointer text-primary" href="https://wallet.advcash.com:443/referral/478d5530-3bce-4a27-a1fd-e923c5994e45" target="_blank">wallet.advcash.com</a> 
                and click Register in the top right corner.
            </p>
            <p>
                2. Select the "Personal" wallet option and fill in all the fields and click the "Register" button. 
            </p>
            <img src="/images/info/adv/adv-reg-en.jpg">
            <p>
                3. After successful registration, you will be taken to a page with information about your account. Click the "Deposit Funds" button.
            </p>
            <img src="/images/info/adv/adv-home-en.jpg">
            <p>
                4. <span class="text-red-500">Be sure to select currency of the payment</span> then enter the amount and choose your country. Click the "Deposit" button.
            </p>
            <img src="/images/info/adv/adv-pay-en.jpg">
            <p>
                5. Enter your card details and click "Pay". On the next screen just click "Continue".
            </p>
            <img src="/images/info/adv/adv-pay-roccess-en.jpg">
            <p>
                6. After successful payment, wait for the funds to be credited to your account and return to this page to pay for the transfer.
            </p>
        </AccordionTab>
        <AccordionTab header="What to do if you entered incorrect recipient information">
            <p>
                If you entered incorrect recipient details, you can close the order and open a new one.
            </p>
            <p>
                If you have already paid for the transfer text to our <span @click="$router.push({path: '/support/'})" class="text-primary underline cursor-pointer">support</span> and we will correct the recipient's data.
            </p>
        </AccordionTab>
        <AccordionTab header="Why you need to register with AdvCash">
            <p>
                AdvCash is a payment system that allows you to make payments all over the world.
                <br>
                To register with AdvCash, you must provide a phone number and email address.
                <br>
                After registration, you will be able to top up the balance of your AdvCash wallet using a bank card or other payment systems.
                <br><br>
                Registration is necessary for your security and avoiding fraud.
                <br>
                Hope for your understanding.
            </p>
        </AccordionTab>
    </Accordion>
    
    <Accordion :activeIndex="activeIndex" class="mt-5" v-if="lang_=='ru'">
        <AccordionTab header="Как провести оплату">
            <p>
                1. Нажмите кнопку оплатить. Вы попадете на страницу платежной системы AdvCash.
            </p>
            <p>
                2. Убедитесь, что вы попали на страницу AdvCash по адресу https://wallet.advcash.com/sci/ и что в адресной строке отображается замок (https протокол).
            </p>
            <p>
                3. Проверьте сумму платежа и номер ордера. Если все верно, нажмите кнопку выберите способ оплаты и нажмите "Перейти к оплате".
            </p>
            <img src="/images/info/adv/adv-page-1-ru.jpg">
            <p>
                4. Введите свой логин и пароль от AdvCash кошелька. 
                <br>
                В случае, если вы не зарегистрированы в AdvCash, нажмите кнопку "Зарегистрироваться" и следуйте инструкциям ниже.
            </p>
            <img src="/images/info/adv/adv-login-ru.jpg">
            <p>
                5. Выберите валюту платежа и произведите оплату. 
            </p>
            <img src="/images/info/adv/adv-page-2-ru.jpg">
            <p>
                6. После успешной оплаты вы попадете на страницу с информацией об оплате. Нажмите кнопку "Вернуться в магазин".
            </p>

            <TabView class="w-full overflow-hidden" v-if="card">
                <TabPanel header="Оплата по карте">
                    <p>
                        4. Введите данные вашей банковской карты в соответствующие поля. Нажмите кнопку "Оплатить". <br>
                        <b>Внимание!</b> Сумма платежа будет чуть больше, чем указанная в ордере. Это связано с комиссией платежной системы.
                    </p>
                    <img src="/images/info/adv-en-2.png">
                    <p>
                        5. После успешной оплаты вы попадете на страницу с информацией об оплате.
                    </p>
                    <p>
                        6. Нажмите кнопку "Вернуться в магазин".
                    </p>
                    <p>
                        7. После этого вы попадете на страницу с информацией о переводе. Нажмите кнопку "Я оплатил перевод".
                    </p>
                </TabPanel>
                <TabPanel header="Через личный кабинет">
                    
                </TabPanel>
            </TabView>                    
        </AccordionTab>
        <AccordionTab header="Как зарегистрироваться и пополнить баланс в AdvCash">
            <p> 
                1. Перейдите на сайт AdvCash по ссылке <a class="cursor-pointer text-primary" href="https://wallet.advcash.com:443/referral/478d5530-3bce-4a27-a1fd-e923c5994e45" target="_blank">wallet.advcash.com</a> и нажмите Регистрация в верхнем правом углу.
            </p>
            <p>
                2. Заполните все поля и нажмите кнопку "Зарегистрироваться". Выберите вариант "Персональный" кошелек.
            </p>
            <img src="/images/info/adv/adv-reg-ru.jpg">
            <p>
                3. После успешной регистрации вы попадете на страницу с информацией о вашем аккаунте. Нажмите кнопку "Пополнение счета".
            </p>
            <img src="/images/info/adv/adv-home-ru.jpg">
            <p>
                4. <span class="text-red-500">Обязательно выберите нужную валюту</span>, введите сумму пополнения и выберите страну. Нажмите кнопку "Пополнить".
            </p>
            <img src="/images/info/adv/adv-pay-ru.jpg">
            <p>
                5. Укажите данные карты и нажмите "Оплатить".
            </p>
            <img src="/images/info/adv/adv-pay-roccess-ru.jpg">
            <p>
                6. После успешной оплаты дождитесь зачисления средств на ваш счет и вернитесь на эту страницу для оплаты перевода.
            </p>
            

        </AccordionTab>
        <AccordionTab header="Что делать если ввел не верные данные получателя">
            <p>
                Если вы ввели не верные данные получателя, то вы можете закрыть ордер и открыть новый. 
            </p>
            <p>
                В случае, если вы уже оплатили перевод, то напишите нам в <span @click="$router.push({path: '/support/'})" class="text-primary underline cursor-pointer">техподдержку</span> и мы поправим данные получателя.
            </p>
        </AccordionTab>
        <AccordionTab header="Почему нужно регистрироваться в AdvCash">
            <p>
                AdvCash - это платежная система, которая позволяет проводить платежи по всему миру. 
                <br>
                Для регистрации в AdvCash необходимо указать номер телефона и адрес электронной почты. 
                <br>
                После регистрации вы сможете пополнять баланс AdvCash кошелька с помощью банковской карты или других платежных систем.
                <br>
                Регистрация необходима для вашей безопасности и исключения случаев мошенничества.
                <br>
                Надеемся на ваше понимание.
            </p>
        </AccordionTab>
    </Accordion>
</template>

<script>
export default {
    name: "PayInfoAdv",
    data() {
        return {
            activeIndex: null,
            lang: 'en',
            card: false
        }
    },
    computed: {
        lang_() {
            return (this.$i18n.locale) ? this.$i18n.locale : 'en'
        }
    },
}
</script>